import React , { useState ,useEffect  , useRef }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import Loaderanimation from 'components/ui/loaderanimation';
import {useCompanyFin} from "contexts/companyfindata/companyfindata.context.tsx"

import {
useCompanyProfitNLoss
} from 'data/company';
import {number_format,APP_URL,formatINR} from 'components/config/Common';

import {useAuth} from 'contexts/provider/AuthProvider';
import LockedOverlay from 'components/ui/LockedOverlay.tsx';
import {Links} from 'routes/PathLink';
import ModalView from '_utils/ModalView'
import LoginwithEmail from "components/auth/user/LoginwithEmail";
import SocialLogin from "components/auth/SocialLogin";

export default function ProfitNLossSection({companyinfo,type}) {

  const {isUser} = useAuth();
      const [open, setOpen] = useState(false);
          
          const openPopup = () => {
              setOpen(true);
          };

      const [openSections, setOpenSections] = useState({});
      const {updatePlData} = useCompanyFin();
      const containerRef = useRef(null);
      const [scrolled, setScrolled] = useState(false);
    // Map to store background color of each parent section
    const parentBgMap = {};
    const toggleSection = (sectionno) => {
      setOpenSections((prev) => ({
        ...prev,
        [sectionno]: !prev[sectionno],
      }));
    };

  
    useEffect(() => {
      // code runs whenever `type` changes
      console.log('Type changed:', type);
    const apiType = type ? 'Standalone' : 'Consolidated';

refetchPF({
  id: companyinfo?.id,
  type: apiType,
  company_type: companyinfo?.company_type
});
    }, [type]);


    

    const {
      profitNloss,
      years_list,
      lable_array:labelArray,
      isLoading: loading,
      error,
      refetch:refetchPF,
    } = useCompanyProfitNLoss({id:companyinfo?.id,
      type:(type?'Standalone':'Consolidated'),
      company_type:companyinfo?.company_type});

    console.log("profitNloss",profitNloss);
    const getTypeByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.type : null;
};
 useEffect(() => {
  if (!loading && profitNloss) {
    updatePlData(profitNloss);
  }
}, [profitNloss, loading]);

  useEffect(() => {
  // If user is on Consolidated page but no data → fallback to Standalone
  if (!type && isEmptyPL) {
    refetchPF({
      id: companyinfo?.id,
      type: 'Standalone',
      company_type: companyinfo?.company_type
    });
  }
}, [profitNloss]);
 const getSecByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.section : null;
};


const getPostfixByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.postfix : null;
};

const getTextcssByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.textbold : null;
};


const getDecimalByName = (periodName) => {
  if (!labelArray) return null;

  const found = Object.values(labelArray).find(
    (item) => item.name.trim() === periodName.trim()
  );

  return found ? found.decimal : null;
};

const isEmptyPL =
  !profitNloss || Object.keys(profitNloss).length === 0;

/** code for scrolling */
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setScrolled(container.scrollLeft > 0);
    };

    container.addEventListener("scroll", handleScroll);

    return () => container.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <>
    <div className="relative">
      <section className="bg-white shadow-md z-50 rounded-xl py-5   ">
        <h2 className="px-5 text-2xl font-semibold ">Profit & Loss</h2>
        
          
          <div className="">
        <div className="text-heading px-5"> Standalone Figures in Rs. Crores / {type? 
               <Link to={`/company/${companyinfo?.symbol}`} className="text-accent underline ml-1">
            View Consolidated
          </Link>
          : 
           <Link to={`/company/${companyinfo?.symbol}/standalone`} className="text-accent underline ml-1">
                View Standalone
              </Link>
        } </div>
          </div>
        {!type && isEmptyPL && (
      <div className="px-5 text-sm text-yellow-600">
        Consolidated data not available. Showing Standalone instead.
      </div>
    )}
        <div className="py-4"></div>
        {loading?
          <div className="h-[200] flex w-full justify-center"><Loaderanimation /></div>
        
        :
        <div ref={containerRef} class="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base ">
            <table 
              
             class="w-full text-sm text-left border-0 rtl:text-right text-body">
                <thead class="bg-neutral-secondary-soft border-b border-default">
                    <tr >
                        <th scope="col" class="px-6 py-2 ">
                           
                        </th>
                         {Object.entries(years_list).map(([keyyear, valyear]) => (
                            <th scope="col" className="text-right px-6 py-2 ">{valyear}</th>
                          ))}
                    </tr>
                </thead>
                <tbody>
                {Object.keys(profitNloss || {}).length === 0 ? (
                  <div className="p-5 text-heading"> data is not ready yet , please check again
                </div>
                    ) : (<>
                {Object.entries(profitNloss).map(([period, qresults],index) => {
                    const type = getTypeByName(period); // or value.name
                  const sectionno = getSecByName(period);

                    const postfix = getPostfixByName(period);
                  const textbold = getTextcssByName(period);
                  const decimalval =  getDecimalByName(period);


                  // If this is a parent row → compute & store bg
                    if (type === "parent") {
                      parentBgMap[sectionno] =
                        index % 2 === 0
                          ? "bg-gray-50"
                          : "bg-white";
                    }

                    // Now rowBg ALWAYS exists (because child uses parent's stored bg)
                    const rowBg = parentBgMap[sectionno] || "bg-white";

                  // Find all children belonging to this section
                  const children = Object.entries(profitNloss).filter(
                    ([p, data]) => getSecByName(p) === sectionno && getTypeByName(p) === "child"
                  );
                   console.log("childrenlist",rowBg);
                  const hasChild = children.length > 0;
                  
                  return(<React.Fragment key={sectionno}>  
                   {type === "parent" &&
                   <tr 
                    className={`${rowBg} ${textbold} cursor-pointer ${openSections[sectionno] ? "border-t-2 " : ""}  `}
                  onClick={() => type === "parent" && toggleSection(sectionno)}                      >
                    
                      <td className={`px-2 md:px-6 py-2 sticky left-0 z-20 ${rowBg} w-10 md:w-fit `} >
                        <div className={`flex gap-1 whitespace-nowrap items-center ${openSections[sectionno] ? "text-accent " : "text-heading"} `}>{period}
                            {hasChild && (
                        <> {openSections[sectionno] ? (
                              <MinusIcon className="w-3 h-3 text-accent" />
                            ) : (
                              <PlusIcon className="w-3 h-3 text-accent" />
                            )}</>
                          )}
                          </div>
                        </td>


                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`text-right px-6 py-3 text-heading  text-wrap `} >{qresultsval ? <>{formatINR(qresultsval,decimalval)}{postfix}</> : null} </td>
                      ))}
                      </tr>
                    }
                      {openSections[sectionno] && type === 'child' &&
                       <tr 
                         className={`${rowBg}  cursor-pointer`}
>                    
                      <td className={`px-6 py-2 text-black sticky left-0 z-30  gap-1 whitespace-nowrap items-center ${rowBg}`} >
                        {period}
                        </td>
                      {Object.entries(qresults).map(([key, qresultsval]) => (
                         
                          <td className={`text-right px-6 py-3  whitespace-nowrap`} >{formatINR(qresultsval,decimalval)} {postfix}</td>
                      ))}
                      </tr>}
                    
                   </React.Fragment>)
                })}
                   </>)}
                </tbody>
            </table>
        </div>
        }
        
      </section> 
      {!isUser && companyinfo?.exchange == 'bse' &&
                            <>
                            <div className="min-h-fit py-10 md:py-0">
                              <img src={`${APP_URL}/img/analysis_placeholder.png`} className="h-10" />
                            </div>
                  <LockedOverlay 
                        show={!isUser}
                      >
                         <p className="text-lg font-semibold mb-3">
                      Login to unlock full analysis
                    </p>
                
                    <Link
                      to={'#'}
                      onClick={openPopup}
                      className="inline-block bg-accent text-white px-4 py-2 rounded-lg font-semibold  transition"
                    >
                      Click Here to Login
                    </Link>
                 </LockedOverlay>
                 </>
                   }
        </div>
        <ModalView open={open} onClose={() => setOpen(false)}>
                            <div className="flex flex-col justify-center">
                                <div className="text-center text-base text-body">Don't have an account? <Link to={`${Links.USER_SIGNUP}`} className="text-accent underline transition-colors duration-200 hover:text-accent-hover hover:no-underline focus:text-accent-hover focus:no-underline focus:outline-none ltr:ml-1 rtl:mr-1">Create New</Link></div>
                                
                      </div>  
                            <LoginwithEmail goTo={window.location.href} />
                            <SocialLogin mode='Login' user_type='user' goTo={window.location.href} />
                        </ModalView>
      </>
  );
}
